import CryptoJS from 'crypto-js';
import CONFIG from "../config";

export const encryptData = (data) => {
    if (CONFIG.IS_JSON) {
        return data;
    }

    try {
        return CryptoJS.AES.encrypt(JSON.stringify(data), CryptoJS.enc.Utf8.parse(CONFIG.DECRYPT_KEY),
            {
                iv: CryptoJS.enc.Utf8.parse(CONFIG.DECRYPT_IV), // parse the IV
                padding: CryptoJS.pad.Pkcs7,
                mode: CryptoJS.mode.CBC
            }).toString();
    } catch (e) {
        return '';
    }
};


export const decryptData = (data) => {
    if (CONFIG.IS_JSON) {
        return data;
    }
    try {
        const cipher = CryptoJS.AES.decrypt(data, CryptoJS.enc.Utf8.parse(CONFIG.DECRYPT_KEY),
            {
                iv: CryptoJS.enc.Utf8.parse(CONFIG.DECRYPT_IV), // parse the IV
                padding: CryptoJS.pad.Pkcs7,
                mode: CryptoJS.mode.CBC
            });
        return JSON.parse(cipher.toString(CryptoJS.enc.Utf8));
    } catch (e) {
        return {};
    }
};